module.exports = __webpack_public_path__ + "static/cup-f6f6cb26f18c8f50f89d0ef92a56f289.png";